import { render } from "./Home.vue?vue&type=template&id=c65ec028&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c65ec028"

export default script